"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

var _ButtonIcon = _interopRequireDefault(require("../ButtonIcon/ButtonIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TimesIcon = function TimesIcon(props) {
  return (0, _themeUi.jsx)("svg", props, (0, _themeUi.jsx)("path", {
    d: "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
  }));
};

TimesIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 352 512"
};

var DrawerControls = function DrawerControls(_ref) {
  var onClose = _ref.onClose,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["onClose", "children"]);

  return (0, _themeUi.jsx)(_themeUi.Flex, _extends({}, props, {
    sx: {
      py: 1,
      px: 2,
      justifyContent: 'flex-start'
    }
  }), onClose && (0, _themeUi.jsx)(_ButtonIcon["default"], {
    icon: TimesIcon,
    onClick: onClose,
    ariaLabel: "Close"
  }), children);
};

DrawerControls.propTypes = {
  onClose: _propTypes["default"].func,
  children: _propTypes["default"].node
};
DrawerControls.defaultProps = {
  onClose: null,
  children: null
};
var _default = DrawerControls;
exports["default"] = _default;